import React from 'react';
import PropTypes from 'prop-types';

const IconTrendTolerableIndicator = ({ width = '16', height = '16', viewBox = '0 0 16 16' }) => {
    return <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox={viewBox} fill='none'>
        <rect width='16' height='16' fill='#FFA200'/>
        <path d='M11.3235 11.4527L13.085 4.87868L6.51096 3.11719L6.03056 4.9101L9.61637 5.87091L2.03865 10.2459L2.91365 11.7615L10.4914 7.38646L9.53056 10.9723L11.3235 11.4527Z' fill='white'/>
    </svg>;
};

IconTrendTolerableIndicator.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    viewBox: PropTypes.string
};

export default React.memo(IconTrendTolerableIndicator);
